import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  reviewContainer: {
    display: "flex",
    gap: 32,
    marginTop: 24
  },
  reviewLeft: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 20
  },
  reviewRight: {
    width: 380,
    display: "flex",
    flexDirection: "column",
    gap: 28,
    border: "1px solid #E4E7EC",
    borderRadius: 8,
    padding: 24,
    background: "#fff"
  },

  outlineCard: {
    borderRadius: 8,
    padding: 24,
    background: "#fff",
    textAlign: "left"
  },
  outlineTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1D2739",
    margin: "0 0 18px 0"
  },
  outlineRow: {
    display: "flex",
    gap: 8,
    marginBottom: 12,
    fontSize: 14,
    color: "#344054",
    textAlign: "left"
  },
  outlineLabel: {
    fontWeight: 700,
    color: "#1D2739",
    whiteSpace: "nowrap"
  },

  contentCard: {
    border: "1px solid #E4E7EC",
    borderRadius: 8,
    padding: 24,
    background: "#fff",
    textAlign: "left",
    "& h5": {
      fontSize: 14,
      fontWeight: 700,
      color: "#1D2739",
      margin: "0 0 10px 0"
    },
    "& p": {
      fontSize: 13,
      color: "#344054",
      lineHeight: 1.8,
      margin: "0 0 14px 0"
    },
    "& ul": {
      paddingLeft: 20,
      margin: "0 0 12px 0"
    },
    "& ul li": {
      fontSize: 13,
      color: "#344054",
      lineHeight: 1.8,
      marginBottom: 10
    }
  },

  signalsCard: {
    textAlign: "left"
  },
  signalsTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#1D2739",
    margin: "0 0 4px 0"
  },
  signalsSubtitle: {
    fontSize: 13,
    color: "#667085",
    margin: "0 0 20px 0",
    fontStyle: "italic"
  },
  signalAlert: {
    borderLeft: "4px solid #DD514D",
    background: "#FAFAFA",
    padding: "14px 18px",
    borderRadius: "0 6px 6px 0"
  },
  signalAlertTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: "#1D2739",
    margin: "0 0 6px 0"
  },
  signalAlertGreen: {
    fontSize: 13,
    color: "#DD514D",
    fontWeight: 600,
    fontStyle: "italic",
    margin: "0 0 4px 0"
  },
  signalAlertGrey: {
    fontSize: 13,
    color: "#667085",
    fontStyle: "italic",
    margin: 0
  },

  // Points Decision Card
  decisionCard: {
    textAlign: "left"
  },
  decisionTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#1D2739",
    margin: "0 0 20px 0"
  },
  decisionLabel: {
    fontSize: 13,
    fontWeight: 500,
    color: "#344054",
    margin: "0 0 6px 0"
  },
  decisionInput: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #E4E7EC",
    borderRadius: 6,
    background: "#F9FAFB",
    fontSize: 14,
    color: "#1D2739",
    outline: "none",
    marginBottom: 16,
    boxSizing: "border-box",
    "&:focus": {
      borderColor: "#1a66f5"
    }
  },
  decisionTextarea: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #E4E7EC",
    borderRadius: 6,
    background: "#F9FAFB",
    fontSize: 14,
    color: "#1D2739",
    outline: "none",
    minHeight: 50,
    resize: "vertical",
    marginBottom: 20,
    boxSizing: "border-box",
    fontFamily: "inherit",
    "&:focus": {
      borderColor: "#1a66f5"
    }
  },
  decisionActions: {
    display: "flex",
    gap: 12,
    justifyContent: "flex-end"
  },

  // Responsive
  "@media (max-width: 768px)": {
    reviewContainer: {
      flexDirection: "column"
    },
    reviewRight: {
      width: "100%"
    }
  }
}));
